const DEPRECATED_LINE_VOLTAGE = 230;

export type PxcVoltageFixResult = {
  data: unknown;
  transformedCount: number;
};

export const applyPxcVoltageFix = (input: unknown): PxcVoltageFixResult => {
  let transformedCount = 0;

  const walk = (value: unknown): unknown => {
    if (Array.isArray(value)) {
      return value.map(walk);
    }
    if (value === null || typeof value !== "object") {
      return value;
    }
    const next: Record<string, unknown> = {};
    for (const [key, child] of Object.entries(
      value as Record<string, unknown>,
    )) {
      next[key] = walk(child);
    }
    if (
      next.line_voltage === DEPRECATED_LINE_VOLTAGE &&
      next.phase_voltage == null
    ) {
      delete next.line_voltage;
      next.phase_voltage = DEPRECATED_LINE_VOLTAGE;
      transformedCount += 1;
    }
    return next;
  };

  const data = walk(input);
  return { data, transformedCount };
};
